export function number (value) {
  return Math.round(value).toLocaleString()
}

export function datetime (value) {
  if (typeof value === 'string') {
    value = new Date(value)
  }
  return value.toLocaleString()
}
